<template>
  <div>
    <button class="cta-button" @click="downloadVCard">Kontakt speichern</button>
  </div>
</template>

<script>
export default {
  name: 'KontaktButton',
  data() {
    return {
      vcardText: `BEGIN:VCARD
VERSION:3.0
N:Röhrig;Maike;;;
FN:Maike Röhrig
ORG:Maikes Familienbegleitung
TITLE:Still-, Schlaf- & Beikostberaterin
TEL;TYPE=CELL:+4915773577671
EMAIL;TYPE=WORK:info@maikes-familienbegleitung.de
URL:https://maikes-familienbegleitung.de
URL;TYPE=Instagram:https://www.instagram.com/maikes_familienbegleitung
ADR;TYPE=WORK:;;Trierer Str. 250A;Koblenz;;56072;Deutschland
END:VCARD`
    };
  },
  methods: {
    downloadVCard() {
      // Erstelle ein Blob-Objekt aus dem vCard-Text
      const blob = new Blob([this.vcardText], { type: 'text/vcard;charset=utf-8' });

      // Erstelle eine URL für das Blob-Objekt
      const url = URL.createObjectURL(blob);

      // Erstelle ein unsichtbares Link-Element
      const link = document.createElement('a');
      link.href = url;
      link.download = 'maikes_familienbegleitung.vcf'; // Dateiname für den Download
      link.style.display = 'none'; // Verstecke den Link

      // Füge den Link zum DOM hinzu und klicke ihn automatisch an
      document.body.appendChild(link);
      link.click();

      // Entferne den Link und gib die Blob-URL frei
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}
</script>

<style>
</style>